
const PayInvoiceModal = ({ item, onSubmit, onClose }) => {
    debugger
    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-5 rounded shadow-lg w-1/2">
                <h2 className="text-2xl font-bold mb-4">Pay Invoice</h2>
                <form onSubmit={onSubmit}>
                    <label className="block mb-2">
                        Total Amount:
                        <input
                            type="text"
                            readOnly
                            value={item.revenue}
                            className="w-full p-2 border border-gray-300 rounded mt-1"
                        />
                    </label>
                    <label className="block mb-2">
                        Deduction Amount:
                        <input
                            type="number"
                            name="DeductionAmount"
                            className="w-full p-2 border border-gray-300 rounded mt-1"
                        />
                    </label>
                    <label className="block mb-2">
                        Deduction Reason:
                        <input
                            type="text"
                            name="DeductionReason"
                            className="w-full p-2 border border-gray-300 rounded mt-1"
                        />
                    </label>
                    <label className="block mb-2">
                        Deduction Image:
                        <input
                            type="file"
                            name="DeductionImage"
                            className="w-full p-2 border border-gray-300 rounded mt-1"
                        />
                    </label>
                    <label className="block mb-2">
                        Payment Type:
                        <select
                            name="PaymentType"
                            className="w-full p-2 border border-gray-300 rounded mt-1"
                        >
                            <option value="">Select Payment Method</option>
                            <option value="Paypal">Paypal</option>
                            <option value="Wire">Wire Transfer</option>
                            <option value="Wise">Wise</option>
                            <option value="Stripe">Stripe</option>
                            <option value="CreditCard">Credit Card</option>
                            <option value="BankTransfer">Bank Transfer</option>
                        </select>
                    </label>
                    <div className="flex justify-end mt-4">
                        <button
                            type="submit"
                            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded mr-2"
                        >
                            Pay Now
                        </button>
                        <button
                            type="button"
                            onClick={onClose}
                            className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded"
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PayInvoiceModal;
